export enum NotificationEvent {
  NewDocument = 1,
  UpdateDocument = 2,
  NewQuestion = 3,
  NewAnswer = 4,
  FirstTimeVisit = 5,
  UserRegistration = 6,
  // wf
  SwimLane = 7,
  Claim = 8,
  Release = 9,
  Reminder = 10,
  Escalation = 11,
  // ssu regulatory approval
  RegulatoryPending = 12,
  RegulatoryApproved = 13,
  RegulatoryRejected = 14,
  // query resolution
  WorkflowQueryResolutionSent = 15,
  AuditQueryResolutionSent = 16,
  NewStartUpDocument = 17,
  UpdateStartUpDocument = 18,
  RejectDocument = 19,
  StartUpSponsorPending = 20,
  StartUpSponsorApproved = 21,
  StartUpSponsorRejected = 22,
}
